import { memo } from 'react'
import { BaseQuantityInput } from './BaseQuantityInput'

interface PackageQuantityUnitInputProps {
  quantity: string
  unit: string
  showCustomUnitInput: boolean
  customUnit: string
  onQuantityChange: (quantity: string) => void
  onUnitChange: (unit: string) => void
  onCustomUnitChange: (value: string) => void
  onUnitDropdownClose: (open: boolean) => void
  placeholder?: string
}

export const PackageQuantityUnitInput = memo<PackageQuantityUnitInputProps>(
  function PackageQuantityUnitInput(props) {
    return (
      <BaseQuantityInput
        {...props}
        label="for a pack of"
        labelWidth="wide"
        ariaLabel="Package quantity and units"
      />
    )
  }
)

PackageQuantityUnitInput.displayName = 'PackageQuantityUnitInput'